import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import Application from './Application';
import { Provider } from 'react-redux';
import { store } from './Store';
import { dappTheme } from '@syncfab/machine';
import CssBaseline from '@mui/material/CssBaseline';
import { GET_LOGGED_USER } from '../components/user/Actions';
import { GET_SUPPLIER_TAGS } from '../components/supplier/Actions';
import { StylesProvider } from '@mui/styles';
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material';
import { routerService } from './services';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

// If there is a valid token, we load the current user
if (!!store.getState().auth.authToken) {
  store.dispatch(GET_LOGGED_USER.actions.TRIGGER());
  store.dispatch(GET_SUPPLIER_TAGS.actions.TRIGGER());
}

ReactDOM.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={dappTheme}>
      <StylesProvider>
        <Provider store={store}>
          <Router history={routerService.getHistory()}>
            <React.Fragment>
              <CssBaseline />
              <Application />
            </React.Fragment>
          </Router>
        </Provider>
      </StylesProvider>
    </ThemeProvider>
  </StyledEngineProvider>,
  document.getElementById('main-container')
);
